export enum StorageKeys {
	GOAL_SETTING_DATA = "goalSettingData",
	QUESTION_DATA = "questionData",
	TASK_DATA = "taskData",
	WORD_LIST_DATA = "wordListData",
	ROUTE_ID = "routeId",
	AUTH_DATA = "__auth-data",
	DUMMY_TOTAL_COMPANIES = "totalCompanies",
	DAILY_MISSION = "dailyMission",
	FEATURE_CONFIG = "featureConfig",
	COMPANY_URLS = "companyUrls",
	JOURNEYMAP_SELECTED = "journeyMapSelected",
	JOURNEYMAP_LIST = "journeyMapList",
	JOURNEYMAP_MAPPED = "journeyMapMapped",

	STORYBUILDER_CHAT_SESSION = "storybuilder-chat-session", // Stored in SessionStorage
	JOURNEYBUILDER_CHAT_SESSION = "journeybuilder-chat-session", // Stored in SessionStorage
	JOURNEY_TEMPLATE = "journeyTemplate",
	MINI_GAME_DATA = "MINI_GAME_DATA",
	ADMIN_PENDING_VERIFICATION = "admin-pending-verification",
}
